import { FlexColumn, useMoment } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { LabelSmall, LabelXSmall, ParagraphXSmall } from 'baseui/typography';
import { memo } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { EVIDENCE_REPORT_DETAIL_PAGE } from '../../../constants/app';
import { useStyles } from '../../../hooks/useStyles';
import { assetStateByIdent } from '../../../storage/assets';
import { gptAlarmTypeNameState } from '../../../storage/gptStates';
import { EvidenceMedia } from '../../../types/evidences';
import EvidenceMetadataDisplay from '../../evidences/EvidenceMetadataDisplay';
import DataDescription from '../../shared/DataDescription';
import MediaThumbnail from '../../shared/MediaThumbnail';

type Props = {
  media: EvidenceMedia;
};

function StreamingMediaItem({ media }: Readonly<Props>) {
  const { theme, css } = useStyles();
  const { id: workspaceId } = useParams();
  const { formatDateFromTs } = useMoment();
  const assetByIdent = useRecoilValue(assetStateByIdent(media.ident));
  const navigate = useNavigate();
  const cardStyles = css({
    ...theme.borders.border300,
    borderRadius: theme.borders.popoverBorderRadius,
    height: 'auto',
    minHeight: '150px',
    width: '100%',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    ':hover': {
      background: theme.colors.buttonTertiaryHover,
    },
  });
  const cardContentStyles = css({
    padding: theme.sizing.scale600,
  });
  const alarmType = useRecoilValue(gptAlarmTypeNameState(media?.alarmType));
  const assetLabel = media.asset?.label || assetByIdent?.label;

  const onSelectMedia = () => {
    navigate(generatePath(EVIDENCE_REPORT_DETAIL_PAGE.route, { id: workspaceId, evidenceId: media._id }));
  };

  return (
    <Block
      className={cardStyles}
      onClick={onSelectMedia}
    >
      <MediaThumbnail
        mediaKey={media.key}
        origin={media.mediaOrigin}
      />
      <FlexColumn
        classNames={cardContentStyles}
        gap={theme.sizing.scale100}
      >
        <LabelSmall
          margin={0}
          style={{ wordBreak: 'break-all', fontWeight: '700' }}
        >
          {media.ident}
        </LabelSmall>
        {assetLabel && assetLabel.length > 0 && (
          <LabelXSmall
            margin={0}
            whiteSpace={'pre-wrap'}
            color={theme.colors.contentSecondary}
            style={{ wordBreak: 'break-all', fontWeight: '600' }}
          >
            ({assetLabel})
          </LabelXSmall>
        )}
        {media.geoReference && media.geoReference.length > 0 && (
          <ParagraphXSmall
            margin={0}
            whiteSpace={'pre-wrap'}
            style={{ wordBreak: 'break-all' }}
          >
            {media.geoReference ?? '-'}
          </ParagraphXSmall>
        )}
        {media.alarmType && alarmType && (
          <DataDescription
            label={`Alarma:`}
            content={alarmType}
          />
        )}
        {alarmType && (
          <DataDescription
            label={`Fecha de alarma:`}
            content={formatDateFromTs(media.created)}
          />
        )}
        <EvidenceMetadataDisplay
          metadata={media.metadata}
          url={media.key}
          wrap
        />
      </FlexColumn>
    </Block>
  );
}

export default memo(StreamingMediaItem);
